import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocCustomRolesRoute: InvariantJiraRoute = {
	name: 'eoc-custom-roles',
	path: '/jira/settings/products/ops/roles',
	exact: true,
};
